import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import PageNav from '../PageNav/'
import IconNav from '../IconNav/'
import logo from '../../../assets/logo.svg'
import logoBlack from '../../../assets/logo-black.svg'
import { Wrap, LogoContainer, PageNavContainer, IconNavContainer, Overlay } from './styles'

class Header extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false
    }
  }

  handleSwitchBranch() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
    this.props.onSwitchBranch()
  }

  handleUserMenuClick() {
    this.setState({
      userMenuActive: !this.state.userMenuActive,
      assortActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  handleAssortClick() {
    this.setState({
      assortActive: !this.state.assortActive,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  handleCompanyClick() {
    this.setState({
      companyActive: !this.state.companyActive,
      userMenuActive: false,
      assortActive: false,
      serviceActive: false
    })
  }

  handleClickContact() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
    this.props.onClickContact()
  }

  handleClickService() {
    this.setState({
      serviceActive: !this.state.serviceActive,
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
    })
  }

  handleClickOutside() {
    this.setState({
      assortActive: false,
      userMenuActive: false,
      companyActive: false,
      serviceActive: false,
    })
  }

  render() {
    return (
      <Wrap>
        <LogoContainer>
          <Link to="/">
            {this.props.color === 'black' ? (
              <img src={logoBlack} alt="logo" width="145" height="164" />
            ) : (
              <img src={logo} alt="logo" width="145" height="164" />
            )}
          </Link>
        </LogoContainer>

        <PageNavContainer>
          <PageNav 
            permissions={this.props.permissions} 
            nrOfOrders={this.props.nrOfOrders}
            onClickAssort={this.handleAssortClick.bind(this)}
            assortActive={this.state.assortActive}
            onClickCompany={this.handleCompanyClick.bind(this)}
            companyActive={this.state.companyActive}
            onClickService={this.handleClickService.bind(this)}
            serviceActive={this.state.serviceActive}
          />
        </PageNavContainer>

        <IconNavContainer>
          <IconNav
            branchName={this.props.branchName}
            onSwitchBranch={this.handleSwitchBranch.bind(this)}
            handleLogout={this.props.handleLogout}
            permissions={this.props.permissions}
            gender={this.props.gender}
            onClickLink={this.handleUserMenuClick.bind(this)}
            userMenuActive={this.state.userMenuActive}
            onClickContact={this.handleClickContact.bind(this)}
          />
        </IconNavContainer>

        {this.state.assortActive || this.state.userMenuActive || this.state.companyActive ? (
          <Overlay onClick={this.handleClickOutside.bind(this)} />
        ) : null}

      </Wrap>
    )
  }
}

export default withRouter(Header)



// WEBPACK FOOTER //
// ./src/components/Header/Header/index.js